(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-navigation"] && !Shopify.designMode) return;
  try {
    
  class MenuNavigation extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('.menu-nav__link'));
      this.navigationType = this.dataset.navigationType || 'default';
      this.targets = [];
      this.rafId = null;
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.links.forEach((link) => link.addEventListener('click', this.onClick));

      if (this.navigationType === 'spy' || this.navigationType === 'anchor') {
        this.initNavigation();
      }
    }

    disconnectedCallback() {
      this.links.forEach((link) => link.removeEventListener('click', this.onClick));
      window.removeEventListener('scroll', this.onScroll);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    initNavigation() {
      this.setupTargets();

      if (!this.targets.length) {
        requestAnimationFrame(() => {
          this.setupTargets();
          if (this.navigationType === 'spy') this.setupSpy();
        });
        return;
      }

      if (this.navigationType === 'spy') this.setupSpy();
    }

    setupTargets() {
      this.targets = this.links
        .map((link) => {
          const hash = this.getHash(link.getAttribute('href'));
          if (!hash) return null;
          const target = this.findTarget(hash);
          if (!target) return null;
          return { link, target, hash };
        })
        .filter(Boolean)
        .sort((a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);
    }

    getHash(href) {
      if (!href) return null;
      if (href.startsWith('#')) return href;
      try {
        const url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin) return null;
        if (url.pathname !== window.location.pathname) return null;
        return url.hash || null;
      } catch (error) {
        return null;
      }
    }

    findTarget(hash) {
      if (!hash || hash === '#') return null;

      const id = decodeURIComponent(hash.slice(1));
      let target = document.getElementById(id);
      if (target) return target;

      try {
        target = document.querySelector(hash);
        if (target) return target;
      } catch (error) {
        // Invalid selector
      }

      const suffix = id.includes('__') ? id.split('__').pop() : id;
      if (!suffix) return null;

      const sections = document.querySelectorAll('.shopify-section[id]');
      for (const section of sections) {
        if (section.id === id || section.id.endsWith(`__${suffix}`) || section.id.endsWith(suffix)) {
          return section;
        }
      }

      return document.getElementById(suffix) || document.querySelector(`[id$="${suffix}"]`);
    }

    getOffset() {
      const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const sectionEl = this.closest('.shopify-section');
      const stickyHeight = sectionEl ? sectionEl.offsetHeight : 0;
      return headerHeight + stickyHeight + 8;
    }

    onClick(event) {
      if (this.navigationType !== 'anchor' && this.navigationType !== 'spy') return;

      const link = event.currentTarget;
      const hash = this.getHash(link.getAttribute('href'));
      if (!hash) return;

      const target = this.findTarget(hash);
      if (!target) return;

      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - this.getOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      history.replaceState(null, '', hash);
      this.setActive(link);
    }

    setupSpy() {
      if (!this.targets.length) return;
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    onScroll() {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        this.updateActiveFromScroll();
      });
    }

    updateActiveFromScroll() {
      if (!this.targets.length) return;

      const offset = this.getOffset();
      let activeItem = this.targets[0];

      for (const item of this.targets) {
        const top = item.target.getBoundingClientRect().top;
        if (top - offset <= 1) {
          activeItem = item;
        } else {
          break;
        }
      }

      if (activeItem) this.setActive(activeItem.link);
    }

    setActive(activeLink) {
      if (!activeLink || this.activeLink === activeLink) return;

      const hadActive = Boolean(this.activeLink);
      this.activeLink = activeLink;

      this.links.forEach((link) => {
        const isActive = link === activeLink;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollActiveIntoView(activeLink, hadActive && !reduceMotion ? 'smooth' : 'auto');
    }

    scrollActiveIntoView(activeLink, behavior) {
      const item = activeLink.closest('.menu-nav__item') || activeLink;
      const scroller = this.getHorizontalScroller(item);
      if (!scroller) return;

      const scrollerRect = scroller.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const padding = 16;
      let delta = 0;

      if (itemRect.left < scrollerRect.left + padding) {
        delta = itemRect.left - scrollerRect.left - padding;
      } else if (itemRect.right > scrollerRect.right - padding) {
        delta = itemRect.right - scrollerRect.right + padding;
      }

      if (delta !== 0) {
        scroller.scrollBy({ left: delta, behavior });
      }
    }

    getHorizontalScroller(element) {
      let node = element.parentElement;

      while (node && node !== this) {
        const overflowX = getComputedStyle(node).overflowX;
        if (
          (overflowX === 'auto' || overflowX === 'scroll') &&
          node.scrollWidth > node.clientWidth + 1
        ) {
          return node;
        }
        node = node.parentElement;
      }

      return null;
    }
  }

  if (!customElements.get('menu-navigation')) {
    customElements.define('menu-navigation', MenuNavigation);
  }

  } catch(e) { console.error(e); }
})();
})();
